exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the Course Certificate module should live here.\n * Import as neede like so:\n * ...\n * import courseCertificateStyles from 'courseCertificateModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"course-certificate-item\">\n * ...\n */\n\n.modules-courseCertificate-___courseCertificateModuleStyles__course-certificate-item___w7Jn8 {\n\n}\n", ""]);

// exports
exports.locals = {
	"course-certificate-item": "modules-courseCertificate-___courseCertificateModuleStyles__course-certificate-item___w7Jn8"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/courseCertificate/courseCertificateModuleStyles.css
// module id = 1348
// module chunks = 1